module.exports = __webpack_public_path__ + "static/media/cigarettes_01_full.85c4b3c7.gif";